<mat-card>
  <div class="form" [formGroup]="_formGroup">
    <div class="fieldset">
      <div class="field">
        <div class="field-title required">
          {{ 'common.bukTicketFormComponent.titles.contents' | translate }}
        </div>
        <ng-content select="#book-select"></ng-content>
        <div class="contents-info">
          <div
            class="flex flex-v-center"
            *ngIf="contents; else contentsPlaceholder"
          >
            <img
              class="thumbnail mat-elevation-z1"
              src="{{ contents.thumbnail }}"
            />
            <div>
              <p class="title">
                {{ contents.title }}
              </p>
              <p class="author text-secondary">
                {{ contents.author }}
              </p>
            </div>
          </div>
          <ng-template #contentsPlaceholder>
            <div class="flex flex-v-center">
              <div class="thumbnail skeleton"></div>
              <div class="flex-item-expand">
                <p class="title skeleton"></p>
                <p class="author skeleton"></p>
              </div>
            </div>
            <div class="flex flex-center text-secondary overlay">
              {{
                'common.bukTicketFormComponent.messages.pleaseSelectBook'
                  | translate
              }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="field half">
        <div class="field-title required">
          {{ 'common.bukTicketFormComponent.titles.expiryDate' | translate }}
          <mat-icon
            class="help-icon"
            color="primary"
            matTooltip="{{
              'common.bukTicketFormComponent.messages.expiryDateDescription'
                | translate
            }}"
            [matTooltipPosition]="'above'"
            >help</mat-icon
          >
        </div>
        <mat-form-field class="full-width no-placeholder paddingless">
          <mat-select formControlName="expiryDate">
            <mat-option
              *ngFor="let expiryDate of _expiryDates"
              [value]="expiryDate"
              >{{ expiryDate | periodTranslate }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <br><br>
        <mat-form-field class="full-width no-placeholder paddingless">
          <input matInput formControlName="expiryDate"
          placeholder="2022-07-07 14:59:59" />
        </mat-form-field>
      </div>
      <div class="field half">
        <div class="field-title required">
          {{ 'common.bukTicketFormComponent.titles.period' | translate }}
          <mat-icon
            class="help-icon"
            color="primary"
            matTooltip="{{
              'common.bukTicketFormComponent.messages.periodDescription'
                | translate
            }}"
            [matTooltipPosition]="'above'"
            >help</mat-icon
          >
        </div>
        <mat-form-field class="full-width no-placeholder paddingless">
          <mat-select required formControlName="period">
            <mat-option *ngFor="let period of _periods" [value]="period">{{
              period | periodTranslate
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="fieldset-divider"></div>
    <div class="fieldset">
      <mat-tab-group
        color="primary"
        [(selectedIndex)]="_issueType"
        (selectedIndexChange)="_onIssueTypeChange()"
      >
        <mat-tab
          label="{{
            'common.bukTicketFormComponent.titles.issueByEmail' | translate
          }}"
        >
          <div class="tab-content">
            <div class="field">
              <div class="field-title required">
                {{
                  'common.bukTicketFormComponent.titles.language' | translate
                }}
              </div>
              <mat-form-field class="no-placeholder paddingless">
                <mat-select required formControlName="language">
                  <mat-option value="ko">한국어</mat-option>
                  <mat-option value="en">English</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field" *ngIf="!hideSenderInfo">
              <div class="field-title required">
                {{ 'common.bukTicketFormComponent.titles.sender' | translate }}
              </div>
              <div>
                <mat-radio-group
                  color="primary"
                  formControlName="sender"
                  class="sender-radio-group"
                >
                  <div class="radio-button flex flex-v-center">
                    <mat-radio-button [value]="'cp'">
                      <div class="sender-type-tag">
                        {{
                          'common.bukTicketFormComponent.titles.senderType-CP'
                            | translate
                        }}
                      </div>
                      {{ cp.name }} ({{
                        cp.contact_info?.email
                          ? cp.contact_info.email
                          : ('common.bukTicketFormComponent.titles.noSenderEmail'
                            | translate)
                      }})
                    </mat-radio-button>
                    <a
                      style="margin-left: 6px; margin-top: 2px"
                      class="mat-caption flex-item-fit"
                      routerLink="/cp/{{ cp.id }}/info"
                      angulartics2On
                      angularticsAction="click_edit_cp_ticket_email"
                      [angularticsLabel]="gaTrackingId"
                      >{{
                        'common.bukTicketFormComponent.actions.editCPInfo'
                          | translate
                      }}</a
                    >
                  </div>
                  <div class="radio-button">
                    <mat-radio-button [value]="'imprint'">
                      <div class="sender-type-tag">
                        {{
                          'common.bukTicketFormComponent.titles.senderType-imprint'
                            | translate
                        }}
                      </div>
                      {{ imprintName }} ({{ _userEmail }})
                    </mat-radio-button>
                  </div>
                </mat-radio-group>
              </div>
            </div>
            <div class="field">
              <div class="field-title required">
                {{
                  'common.bukTicketFormComponent.titles.receiver' | translate
                }}
              </div>
              <mat-form-field
                class="full-width no-placeholder"
                [floatLabel]="'never'"
              >
                <mat-chip-list #chipList>
                  <ng-container *ngFor="let email of _emails; let i = index">
                    <mat-chip
                      *ngIf="!_isEmailCollapsed || i < 5"
                      [selectable]="true"
                      [removable]="true"
                      (removed)="_onEmailChipRemoved(email)"
                      (click)="_onEmailChipClick()"
                      #chip
                    >
                      {{ email }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </ng-container>
                  <mat-chip
                    *ngIf="_isEmailCollapsed && _emails.length > 5"
                    [selectable]="false"
                    (click)="_onEmailChipClick()"
                  >
                    {{
                      'cp.MORE_EMAIL' | translate: { more: _emails.length - 5 }
                    }}
                  </mat-chip>
                  <span class="input-wrap">
                    <input
                      placeholder="{{
                        'common.bukTicketFormComponent.titles.email' | translate
                      }}"
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="_separatorKeysCodes"
                      [matChipInputAddOnBlur]="true"
                      (matChipInputTokenEnd)="_onEmailChipInputTokenEnd($event)"
                      (focus)="_onEmailInputFocus()"
                      (paste)="_onEmailPaste($event)"
                      (blur)="_onEmailInputBlur()"
                      (input)="_emailInputChange$.next($event)"
                    />
                  </span>
                </mat-chip-list>
                <mat-hint
                  >{{
                    'common.bukTicketFormComponent.messages.separate'
                      | translate
                  }}
                  <span
                    class="import-button"
                    (click)="$event.stopPropagation(); fileUpload.click()"
                    angulartics2On
                    angularticsAction="click_import_ticket_emails"
                    [angularticsLabel]="gaTrackingId"
                    >{{
                      'common.bukTicketFormComponent.actions.import' | translate
                    }}</span
                  ></mat-hint
                >
                <input
                  #fileUpload
                  style="display: none"
                  type="file"
                  multiple
                  (change)="_onFileChange($event.target.files)"
                  accept=".txt,.csv,.xlsx,.xls"
                />
              </mat-form-field>
            </div>
            <div class="field">
              <div class="field-title">
                {{ 'common.bukTicketFormComponent.titles.message' | translate }}
              </div>
              <mat-form-field
                class="full-width paddingless no-placeholder"
                appearance="outline"
              >
                <textarea
                  matInput
                  formControlName="message"
                  mat-autosize
                  cdkTextareaAutosize="true"
                  matAutosizeMinRows="1"
                  matAutosizeMaxRows="5"
                  placeholder=""
                ></textarea>
              </mat-form-field>
            </div>
            <div class="field submit">
              <button
                mat-raised-button
                color="primary"
                (click)="onIssueClick()"
                [disabled]="disableIssue || invalid"
              >
                {{ 'common.bukTicketFormComponent.actions.send' | translate }}
              </button>
            </div>
          </div>
        </mat-tab>
        <mat-tab
          label="{{
            'common.bukTicketFormComponent.titles.issueTicketNumberOnly'
              | translate
          }}"
        >
          <div class="tab-content">
            <p class="mat-body-1 text-secondary ticket-number-description">
              {{
                'common.bukTicketFormComponent.messages.issueTicketNumberOnlyDescription'
                  | translate
              }}
            </p>
            <div class="field">
              <div class="field-title required">
                {{ 'common.bukTicketFormComponent.titles.count' | translate }}
              </div>
              <mat-form-field class="full-width no-placeholder">
                <input
                  required
                  matInput
                  formControlName="count"
                  type="number"
                />
                <mat-hint>
                  {{
                    'common.bukTicketFormComponent.messages.countRangeHint'
                      | translate
                  }}
                  {{
                    ', @buk.io 계정 최대 10만개 발행가능' | translate
                  }}
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="field submit">
              <button
                mat-raised-button
                color="primary"
                (click)="onIssueClick()"
                [disabled]="disableIssue || invalid"
              >
                {{ 'common.bukTicketFormComponent.actions.send' | translate }}
              </button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</mat-card>
